import { GeneralHttpResponse } from "../types/genericTypes";
import axios from "axios";
import env from "react-dotenv";

export const createOrdenCompraHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/createOrdenCompra`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getOrdenCompraPorIdHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getOrdenCompraPorId`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const aceptarOrdenCompraHttp = async (data: any) => {
  try {
    const response: GeneralHttpResponse = await axios.put(
      `${env.API_URL}/aceptarOrdenCompra`,
      data
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const subirPDFFacturaHttp = async (formData: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/subirPDFFactura`,
      formData
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const validarFacturaOrdenCompraHttp = async (formData: FormData) => {
  try {
    const response: GeneralHttpResponse = await axios.post(
      `${env.API_URL}/validarFacturaOrdenCompra`,
      formData
    );
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getOrdenesCompraHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getOrdenesCompra`, {
      params: datos,
    });
    return response?.data?.data || response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
export const getBitacoraOrdenCompraHttp = async (datos?: number) => {
  try {
    const response = await axios.get(`${env.API_URL}/getBitacoraOrdenCompra`, {
      params: datos,
    });
    return response?.data || [];
  } catch (error) {
    const promise = new Promise((_, reject) => reject(error));
    return promise;
  }
};
